export const SET_IS_CHILD_ENROLLMENT_ALLOWED = "SET_IS_CHILD_ENROLLMENT_ALLOWED";

export interface IChildMonitoringServiceState {
    isChildEnrollmentAllowed?: boolean;
}

export interface GetChildEnrollmentAllowedAction {
    type: "SET_IS_CHILD_ENROLLMENT_ALLOWED";
    isChildEnrollmentAllowed: boolean;
}

export type KnownAction = GetChildEnrollmentAllowedAction;
